
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'ImageComponent',

  data: function () {
    const vnode = (Math.random() + 1).toString(36).substring(7);
    return {
      swiperOptions: {
        spaceBetween: 20,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          prevEl: `#button-navigation-${vnode}-prev`,
          nextEl: `#button-navigation-${vnode}-next`,
        },
      },
      vnode,

      activeIndex: 0,
    };
  },

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    promotions: function () {
      return (this.product?.promotions || []).map((t) => ({
        ...t,
        url: t?.dynamicFields?.custom_url || t.url,
      }));
    },
    images: function () {
      return this.product?.imageIds || [];
    },
    imageHref: function () {
      if (!this.product?.imageId) {
        return '';
      }
      return this.$img(String(this.product?.imageId));
    },

    productPresence: function () {
      const characteristics = [];
      (this.product?.characteristics || []).map((t) => {
        characteristics.push(...(t?.characteristics || []));
      });

      const nalicieTovara = (characteristics || []).find((t) => t.slug === 'nalicie-tovara')?.values?.[0];
      if (nalicieTovara) {
        return nalicieTovara?.value;
      }

      return 'Уточнить';
    },
    productQuantity: function () {
      return this.product?.quantity || 0;
    },
    productQuantityUnit: function () {
      return (this.product?.unit || '').replace('/', '');
    },
  },

  components: {
    Swiper,
    SwiperSlide,
  },

  methods: {
    slideChange: function () {
      this.activeIndex = this.$refs.refSwiper.$swiper.realIndex;
    },
    setActiveSlide: function (index) {
      this.$refs.refSwiper.$swiper.slideTo(index);
    },
    openImagePopUp: function (index) {
      this.$store.commit('pop-up-images/open', {
        images: this.images,
        activeSlide: index,
      });
    },
  },
};
